import { AccountStatus } from 'modules/common/components/AccountStatus';
import { useIsMDDown } from 'uiKit/Theme/useTheme';

import { HeaderContent } from './components/HeaderContent';
import { useHeaderStyles } from './useHeaderStyles';
import { useTopBannersHeight } from '../TopBannersHeightProvider';

export interface HeaderProps {
  className?: string;
}

export const Header = ({ className }: HeaderProps) => {
  const { topBannersHeight } = useTopBannersHeight();

  const isMdDown = useIsMDDown();

  const { classes, cx } = useHeaderStyles({
    topBannersHeight,
  });

  return (
    <header className={cx(classes.root, className)}>
      <div className={classes.left}>{!isMdDown && <AccountStatus />}</div>
      <div className={classes.right}>
        <div className={classes.buttons}>
          <HeaderContent />
        </div>
      </div>
    </header>
  );
};
